import { ConversationView } from './ConversationView';
import { MeteredArticleCountObj } from '@Engage.Data.Constants';
import { customTime } from '@Engage.Core';
export class MeterView {
    constructor(meterLevel, meterData, cookieViewData = null) {
        this.conversations = [];
        this.conversationsViews = [];
        const meterCookieData = cookieViewData && cookieViewData[meterLevel] ? cookieViewData[meterLevel] : {};
        this.meterLevel = meterLevel;
        this.conversations = meterData.Conversations || [];
        this.activeConversationId = Number.isInteger(meterData.ActiveConversationId) ? meterData.ActiveConversationId
            : (meterCookieData[MeteredArticleCountObj.ActiveConvoId] != null ? parseInt(meterCookieData[MeteredArticleCountObj.ActiveConvoId], 10) || -1 : -1);
        this.activeConversationCode = meterData.ActiveConversationCode || meterCookieData[MeteredArticleCountObj.ActiveConvoCode] || 'null';
        this.articleCount = meterData.ArticleCount || meterCookieData['_ac'] || 0;
        this.deviceArticleCount = meterData.DeviceArticleCount || meterCookieData['_ac_d'] || 0;
        if (this.conversations.length) {
            this.conversationsViews = this.generateConversationsView();
        }
        else {
            for (const key in meterCookieData) {
                if (key !== MeteredArticleCountObj.ActiveConvoCode && key !== '_ac' && key !== '_ac_d' && key) {
                    this.conversationsViews.push(new ConversationView({}, meterCookieData[key], null, key));
                }
            }
        }
    }
    generateConversationsView() {
        return this.conversations.map(convo => new ConversationView(convo));
    }
    renderCookieObject() {
        const obj = {
            '_ac_d': this.deviceArticleCount,
            '_ac': this.articleCount,
            [MeteredArticleCountObj.ActiveConvoCode]: this.activeConversationCode
        };
        Object.assign(obj, this.renderConversationsViewCookie());
        return obj;
    }
    renderConversationsViewCookie() {
        const conversationViews = {};
        this.conversationsViews.forEach(cv => {
            conversationViews[cv.code] = cv.renderCookieObject();
        });
        return conversationViews;
    }
    increment() {
        // Always increment meter-level counts for every page view
        this.articleCount++;
        this.deviceArticleCount++;
        // Only increment conversation-level counts when a real conversation is active
        if (this.activeConversationView && this.activeConversationView.code !== 'null') {
            this.activeConversationView.increment();
        }
    }
    reduceArticleCount() {
        var _a;
        (_a = this.activeConversationView) === null || _a === void 0 ? void 0 : _a.reduceArticleCount();
    }
    isFreeArticleAvailable() {
        return this.activeConversationView ? this.activeConversationView.isFreeArticleAvailable() : 0;
    }
    updateStartDate(date) {
        var _a;
        (_a = this.activeConversationView) === null || _a === void 0 ? void 0 : _a.setStartDate(date);
    }
    getConversationStartDate() {
        var _a;
        return (_a = this.activeConversationView) === null || _a === void 0 ? void 0 : _a.getStartDate();
    }
    getCurrentConversationViewCount() {
        return this.activeConversationView ? this.activeConversationView.getViewCount() : 0;
    }
    setCurrentConversationViewCount(viewCount) {
        var _a;
        (_a = this.activeConversationView) === null || _a === void 0 ? void 0 : _a.setViewCount(viewCount);
    }
    setActiveConversation(conversationCode, conversationId) {
        this.activeConversationId = conversationId !== null && conversationId !== void 0 ? conversationId : -1;
        this.activeConversationCode = conversationCode !== null && conversationCode !== void 0 ? conversationCode : 'null';
        // No real conversation assigned — nothing to track
        if (!conversationCode || conversationCode === 'null')
            return;
        const existing = this.conversationsViews.find((cv) => cv.code === this.activeConversationCode);
        if (existing) {
            this.activeConversationView = existing;
            // always update Id from the authoritative paywall response
            if (conversationId && conversationId > 0) {
                this.activeConversationView.id = conversationId;
            }
            if (!this.activeConversationView.startDate) {
                this.activeConversationView.setStartDate(customTime.get());
            }
        }
        else {
            const newView = new ConversationView({
                Id: this.activeConversationId,
                Code: this.activeConversationCode,
                ViewCount: 0,
                DeviceViewCount: 0,
                StartDate: customTime.get(),
                FreeArticlesRemaining: 0,
                freeArticlesRepeatable: []
            });
            this.activeConversationView = newView;
            this.conversationsViews.push(newView);
        }
    }
    resetConversationView(conversationCode) {
        const cv = this.conversationsViews.find((v) => v.code === conversationCode);
        if (cv) {
            this.articleCount = Math.max(0, this.articleCount - cv.viewCount);
            this.deviceArticleCount = Math.max(0, this.deviceArticleCount - cv.deviceViewCount);
            cv.reset();
        }
    }
    reset() {
        this.articleCount = 0;
        this.deviceArticleCount = 0;
        this.conversationsViews.forEach(cv => cv.reset());
    }
    getViewData() {
        const conversations = this.conversationsViews
            .filter(cv => cv.code && cv.code !== 'null')
            .map(cv => ({
            StartDate: cv.startDate,
            ViewCount: cv.viewCount,
            DeviceViewCount: cv.deviceViewCount,
            Id: typeof cv.id === 'number' ? cv.id : parseInt(cv.id, 10) || 0,
            Code: cv.code,
            FreeArticlesRemaining: cv.FreeArticlesRemaining,
            freeArticlesRepeatable: cv.freeArticlesRepeatable
        }));
        const result = {};
        result[this.meterLevel] = {
            ActiveConversationId: typeof this.activeConversationId === 'number' ? this.activeConversationId : parseInt(this.activeConversationId, 10) || 0,
            ActiveConversationCode: this.activeConversationCode,
            ArticleCount: this.articleCount,
            DeviceArticleCount: this.deviceArticleCount,
            Conversations: conversations
        };
        return result;
    }
}
